import React from 'react';
import {
  Dialog as MuiDialog, Box,
  Slide
} from '@material-ui/core';
import { DialogActions, DialogContent, DialogText, DialogTitle } from '../styles';
import { ButtonSubmit, ButtonCancel } from 'components/shared/Form';
import { TransitionProps } from '@material-ui/core/transitions';
import { useRouter } from 'hooks';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    dialog: {
      margin: 'auto auto',
      '& .MuiDialog-paper': {
        margin: '0'
      },
      '& .MuiDialogContent-root:first-child': {
        paddingTop: '0'
      }
    }
  })
);


const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface IDialogProps {
  title: string;
  text: string | JSX.Element;
  onClick?: any;
  onClose?: any;
  onClickYes?: string;
  onClickNo?: string;
  open: boolean;
  alignItems?: 'center' | 'flex-end' | 'flex-start';
}

export default function DialogYesNo({ title, text, onClose, onClick, onClickYes, onClickNo, open, alignItems = 'flex-start' }: IDialogProps) {
  const router = useRouter();
  const classes = useStyles();

  const handleClickYes = () => {
    onClick();
    if (onClickYes) return router.push(`/${onClickYes}`);
  }

  const handleClickNo = () => {
    onClose();
    if (onClickNo) router.push(`/${onClickNo}`);
  }

  return (
    <MuiDialog
      fullWidth
      maxWidth="sm"
      className={classes.dialog}
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-labelledby="dialog-slide-title"
      aria-describedby="dialog-slide-description"
    >
      <Box display="flex" flexDirection="column" alignItems={alignItems} p={3}>
        <DialogTitle id="dialog-slide-title">{title}</DialogTitle>
        <DialogContent>
          <DialogText id="dialog-slide-description">
            {text}
          </DialogText>
        </DialogContent>
        <DialogActions>
          <ButtonCancel onClick={handleClickNo} color="primary">
            Não
          </ButtonCancel>
          <ButtonSubmit onClick={handleClickYes} color="primary" style={{ marginLeft: '16px' }}>
            Sim
          </ButtonSubmit>
        </DialogActions>
      </Box>
    </MuiDialog>
  );
}